<modus-wc-theme-provider>
  <div class="app-container">
    <header class="app-header">
      <div class="header-brand">
        <img
          class="header-logo"
          [src]="themeService.currentTheme() === 'dark' ? '/trimble-emblem-dark.svg' : '/trimble-emblem.svg'"
          alt="Trimble"
          width="40"
          height="38"
          [id]="getTestId('Header', 'Logo', 'Trimble')"
          [attr.data-test-field]="getTestId('Header', 'Logo', 'Trimble')"
        />
        <div class="header-title-block">
          <span class="header-title">Site Capture Integration Tool</span>
          @if (headerAreaSubtitle(); as areaLabel) {
            <span
              class="header-area-subtitle"
              [id]="getTestId('Header', 'Text', 'AreaSubtitle')"
              [attr.data-test-field]="getTestId('Header', 'Text', 'AreaSubtitle')"
            >
              {{ areaLabel }}
            </span>
          }
        </div>
      </div>
      <div class="header-actions">
        <modus-wc-tooltip content="Toggle theme" position="bottom">
          <modus-wc-theme-switcher
            [id]="getTestId('Header', 'Switcher', 'ThemeToggle')"
            [attr.data-test-field]="getTestId('Header', 'Switcher', 'ThemeToggle')"
            (themeChange)="onModusThemeChange($event)"
            aria-label="Theme toggle"
          ></modus-wc-theme-switcher>
        </modus-wc-tooltip>
        @if (agenticChat.enabled) {
          <modus-wc-tooltip content="AI Assistant" position="bottom">
            <button
              type="button"
              class="agentic-chat-toggle"
              [class.agentic-chat-toggle--open]="agenticChat.isOpen()"
              [id]="getTestId('Header', 'Button', 'AiAssistant')"
              [attr.data-test-field]="getTestId('Header', 'Button', 'AiAssistant')"
              [attr.aria-pressed]="agenticChat.isOpen()"
              aria-label="AI Assistant"
              (click)="agenticChat.toggle()"
            >
              <img src="/trimble-intelligence-logo.png" alt="" width="24" height="24" />
            </button>
          </modus-wc-tooltip>
        }
        <modus-wc-tooltip
          class="account-menu-tooltip"
          content="Account"
          position="bottom"
          [disabled]="isAccountMenuOpen()"
        >
          <modus-wc-dropdown-menu
            class="account-menu-dropdown"
            [id]="getTestId('Header', 'DropdownMenu', 'AccountMenu')"
            [attr.data-test-field]="getTestId('Header', 'DropdownMenu', 'AccountMenu')"
            buttonAriaLabel="Account"
            [buttonVariant]="'filled'"
            [buttonColor]="'tertiary'"
            buttonSize="md"
            [buttonShape]="'circle'"
            menuPlacement="bottom-end"
            [menuVisible]="isAccountMenuOpen()"
            (menuVisibilityChange)="onAccountMenuVisibilityChange($event)"
          >
            <modus-wc-icon slot="button" name="user_account" size="md" decorative></modus-wc-icon>
            <div slot="menu">
              @if (showChangeRoleInAccountMenu()) {
                <modus-wc-menu-item
                  label="Change role"
                  value="change-role"
                  size="md"
                  [id]="getTestId('Header', 'MenuItem', 'OpenSelectRole')"
                  [attr.data-test-field]="getTestId('Header', 'MenuItem', 'OpenSelectRole')"
                  (itemSelect)="onAccountMenuItemSelect($event)"
                >
                  <modus-wc-icon slot="start-icon" name="swap_horiz" size="sm" decorative></modus-wc-icon>
                </modus-wc-menu-item>
              }
              <modus-wc-menu-item
                label="Logout"
                value="logout"
                size="md"
                [id]="getTestId('Header', 'MenuItem', 'Logout')"
                [attr.data-test-field]="getTestId('Header', 'MenuItem', 'Logout')"
                (itemSelect)="onAccountMenuItemSelect($event)"
              >
                <modus-wc-icon slot="start-icon" name="sign_out" size="sm" decorative></modus-wc-icon>
              </modus-wc-menu-item>
            </div>
          </modus-wc-dropdown-menu>
        </modus-wc-tooltip>
      </div>
    </header>

    <div class="app-assist-shell">
      <div class="app-workspace-region agentic-chat-drawer-host">
        <div class="app-workspace" #agenticChatPushTarget>
          @if (layoutService.pageInfo().hideNavBar !== true) {
            <modus-wc-card
              class="app-workspace-card"
              customClass="app-workspace-card"
              padding="compact"
              [id]="getTestId('Workspace', 'Card', 'PageContent')"
              [attr.data-test-field]="getTestId('Workspace', 'Card', 'PageContent')"
            >
              <div class="app-workspace-card-inner">
                <div class="nav-bar">
                  <modus-wc-breadcrumbs
                    class="app-breadcrumbs"
                    aria-label="Page path"
                    size="sm"
                    appBreadcrumbTooltips
                    [breadcrumbTooltipItems]="modusBreadcrumbItems()"
                    [items]="modusBreadcrumbItems()"
                    [id]="getTestId('Nav', 'Breadcrumbs', 'PagePath')"
                    [attr.data-test-field]="getTestId('Nav', 'Breadcrumbs', 'PagePath')"
                    (breadcrumbClick)="onBreadcrumbClick($event)"
                  ></modus-wc-breadcrumbs>
                  <span class="nav-title">{{ layoutService.pageInfo().title }}</span>
                  <div class="nav-actions">
                    @if (layoutService.pageInfo().actions && layoutService.pageInfo().actions!.length > 0) {
                      @for (action of layoutService.pageInfo().actions; track action.label) {
                        <modus-wc-button
                          [id]="getTestId('Nav', 'Button', 'Action', action.label)"
                          [attr.data-test-field]="getTestId('Nav', 'Button', 'Action', action.label)"
                          size="sm"
                          [variant]="getPageActionVariant(action)"
                          [color]="getPageActionModusColor(action)"
                          [customClass]="getPageActionCustomClass(action) ?? ''"
                          (click)="action.callback()"
                        >
                          {{ action.label }}
                        </modus-wc-button>
                      }
                    }
                    @if (layoutService.pageInfo().hideAddButton !== true) {
                      @if (layoutService.pageInfo().addButtonDisabled) {
                        <modus-wc-tooltip
                          [content]="layoutService.pageInfo().addButtonDisabledReason ?? 'Add is unavailable'"
                          position="bottom"
                        >
                          <modus-wc-button
                            [id]="getTestId('Nav', 'Button', 'Add')"
                            [attr.data-test-field]="getTestId('Nav', 'Button', 'Add')"
                            size="sm"
                            variant="filled"
                            color="primary"
                            [disabled]="true"
                          >
                            Add
                          </modus-wc-button>
                        </modus-wc-tooltip>
                      } @else {
                        <modus-wc-button
                          [id]="getTestId('Nav', 'Button', 'Add')"
                          [attr.data-test-field]="getTestId('Nav', 'Button', 'Add')"
                          size="sm"
                          variant="filled"
                          color="primary"
                          (click)="onAddClick()"
                        >
                          Add
                        </modus-wc-button>
                      }
                    }
                  </div>
                </div>
                <main class="main-content main-content--in-card">
                  <router-outlet />
                </main>
              </div>
            </modus-wc-card>
          } @else {
            <main class="main-content main-content--fill-viewport">
              <router-outlet />
            </main>
          }
        </div>
        @if (agenticChat.enabled) {
          <app-agentic-chat-panel [pushTarget]="agenticChatPushTarget" />
        }
      </div>
    </div>
  </div>
  <app-global-loader />
  <app-uploads-tray />
  <app-toast-host />
</modus-wc-theme-provider>
